import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { IconButtonComponent } from '../../custom-buttons';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'tran-base-file-item',
    imports: [IconButtonComponent, TranslatePipe],
    templateUrl: './base-file-item.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BaseFileItemComponent {
    public readonly fileName = input<string>('');
    public readonly fileSize = input<string | number | undefined>(undefined);
    public readonly downloadEnabled = input<boolean>(false);
    public readonly deleteEnabled = input<boolean>(false);
    public readonly undoDeleteEnabled = input<boolean>(false);
    public readonly isDeleted = input<boolean>(false);
    public readonly download = output<void>();
    public readonly delete = output<void>();
    public readonly undoDelete = output<void>();
}
